import { LineHelpCircle } from '@qr-front/icons/line-help-circle'
import { Button } from '@qr-front/ui/components/Button'
import { LogoLink } from 'components/LogoLink/LogoLink'
import { BUILDER_EDIT_MODES, ROUTES } from 'constants/routesConstants'
import { useAtomValue } from 'jotai'
import { useSearchParams } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import { HeaderContainer } from '@/components/HeaderContainer'
import { userAtom } from '@/global-state'
import { usePathname } from '@/i18n-routing'
import { isNeverPaidUser } from '@/utils/user/isNeverPaidUser'

import {
	captureBuilderEvent,
	STEP_TO_INDEX,
	STEP_TO_NAME,
} from '../../builderAnalytics'
import { GENERATOR_SEARCH_PARAM } from '../../generatorTypes'
import { useCurrGeneratorStep } from '../../hooks/useCurrGeneratorStep'
import { HelpDialog } from '../DialogHelp'
import { GeneratorMobileHeaderContent } from './GeneratorMobileHeaderContent'

export const BaseGeneratorHeader = () => {
	const t = useTranslations()
	const searchParams = useSearchParams()
	const pathname = usePathname()
	const user = useAtomValue(userAtom)

	const isNeverPaid = isNeverPaidUser(user)
	const isOnTypeStep = pathname === ROUTES.generator.typeStep
	const hasQrId = searchParams.get(GENERATOR_SEARCH_PARAM.Id) !== null
	const shouldDisableLogoClick = isNeverPaid && (isOnTypeStep || hasQrId)

	const isEditMode =
		searchParams.get(GENERATOR_SEARCH_PARAM.Target) !== null &&
		searchParams.get(GENERATOR_SEARCH_PARAM.Edit) ===
			BUILDER_EDIT_MODES.CONTENT

	const isChangeTypeMode =
		searchParams.get(GENERATOR_SEARCH_PARAM.Target) !== null &&
		searchParams.get(GENERATOR_SEARCH_PARAM.Edit) ===
			BUILDER_EDIT_MODES.TYPE

	const [isHelpPopupOpen, setIsHelpPopupOpen] = useState(false)
	const currStep = useCurrGeneratorStep()

	const handleHelpClick = () => {
		captureBuilderEvent('builder_click_help', {
			step_index: STEP_TO_INDEX[currStep],
			step_name: STEP_TO_NAME[currStep],
			section: 'app_header',
		})
		setIsHelpPopupOpen(true)
	}

	return (
		<>
			<HeaderContainer className="shadow-[inset_0_-1px_0_0_theme('colors.border-grey-50')]">
				<div className="mx-auto gap-8 desktop:grid desktop:max-w-desktop-container desktop:grid-cols-12">
					<GeneratorMobileHeaderContent
						isEditMode={isEditMode}
						isChangeTypeMode={isChangeTypeMode}
					/>
					<div className="col-span-full col-start-1 hidden items-center justify-between desktop:col-span-9 desktop:flex">
						<LogoLink
							href={
								isNeverPaid
									? ROUTES.generator.typeStep
									: ROUTES.index
							}
							isDisabled={shouldDisableLogoClick}
						/>
						<div className="flex items-center gap-2">
							<Button
								visual="ghost-accent"
								onClick={handleHelpClick}
								className="flex gap-0.5"
							>
								<LineHelpCircle />
								<span className="type-body-small font-medium">
									{t('generator__header__help_button')}
								</span>
							</Button>
						</div>
					</div>
				</div>
			</HeaderContainer>
			<HelpDialog
				isOpen={isHelpPopupOpen}
				setIsOpen={setIsHelpPopupOpen}
			/>
		</>
	)
}
